import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { Button, EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

type ContactsWaterfallErrorViewProps = {
    resetErrorBoundary: () => void;
};

export const ContactsWaterfallErrorView = ({ resetErrorBoundary }: ContactsWaterfallErrorViewProps) => {
    const { translate } = useTranslate();

    const renderCtaButton = () => (
        <Button
            onClick={resetErrorBoundary}
            data-automation="contacts-waterfall-error-retry"
        >
            {translate("si.common.refresh")}
        </Button>
    );

    const renderImage = () => <SWReactIcons iconName="empty-state-browser" />;

    return (
        <Flex
            flex="1"
            justifyContent="center"
            width="100%"
            data-automation="contacts-waterfall-error-view"
        >
            <EmptyState
                title={translate("common.error")}
                SvgImage={renderImage}
                CtaButtons={renderCtaButton}
                subtitle={translate("si.common.error.reload")}
            />
        </Flex>
    );
};
